import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import { receiptKeys } from '@/lib/queryKeys';
import { resendReceiptToast, showReceiptToast } from './receipt-delivery-toast';
import type { Receipt, ReceiptDeliveryResult } from './types';

export interface ResendReceiptInput {
  id: string;
  channels: ('email' | 'sms')[];
  emailOverride?: string;
  smsOverride?: string;
}

type ResendReceiptPayload = Omit<ResendReceiptInput, 'id'>;

interface ResendResponse {
  receipt: Receipt;
  delivered: ReceiptDeliveryResult[];
}

export function useResendReceipt() {
  const queryClient = useQueryClient();
  return useApiMutation<ResendResponse, ResendReceiptInput>({
    mutationFn: async ({ id, channels, emailOverride, smsOverride }) =>
      apiPost<ResendResponse, ResendReceiptPayload>(
        operationsClient,
        endpoints.receipts.resend(id),
        {
          channels,
          emailOverride,
          smsOverride,
        },
      ),
    onSuccess: (response) => {
      showReceiptToast(resendReceiptToast(response.delivered));
      void queryClient.invalidateQueries({ queryKey: receiptKeys.all() });
    },
  });
}
